module.exports = "/images/logo_ripph.png?9a5cc3c9061bde87083652db61229aa7";


//////////////////
// WEBPACK FOOTER
// ./resources/js/components/img/logo_ripph.png
// module id = IdbA
// module chunks = 70